module.exports = __webpack_public_path__ + "static/media/email-icon.484b9946.png";